import { render } from "./NavigationLayout.vue?vue&type=template&id=9bd8dc76&scoped=true"
import script from "./NavigationLayout.vue?vue&type=script&lang=js"
export * from "./NavigationLayout.vue?vue&type=script&lang=js"

import "./NavigationLayout.vue?vue&type=style&index=0&id=9bd8dc76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd8dc76"]])

export default __exports__